import { render, staticRenderFns } from "./WatchlistDomains.vue?vue&type=template&id=5f7c254a&"
import script from "./WatchlistDomains.vue?vue&type=script&lang=js&"
export * from "./WatchlistDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports